export default {
    SUBMIT_IMPORTAR_PEDIDOS_EXCEL: 'SUBMIT_IMPORTAR_PEDIDOS_EXCEL',
    SUBMIT_IMPORTAR_PEDIDOS_EXCEL_SUCCESS: 'SUBMIT_IMPORTAR_PEDIDOS_EXCEL_SUCCESS',
    ABRIR_MODAL_IMPORTAR_PEDIDOS_EXCEL: 'ABRIR_MODAL_IMPORTAR_PEDIDOS_EXCEL',
    CERRAR_MODAL_IMPORTAR_PEDIDOS_EXCEL: 'CERRAR_MODAL_IMPORTAR_PEDIDOS_EXCEL',
    SUBIR_ARCHIVOS_IMPORTAR_PEDIDOS_EXCEL: 'SUBIR_ARCHIVOS_IMPORTAR_PEDIDOS_EXCEL',
    DESCARGAR_PLANTILLA_EXCEL_PEDIDOS_EXCEL: 'DESCARGAR_PLANTILLA_EXCEL_PEDIDOS_EXCEL',
    DESCARGAR_PEDIDOS_EXCEL: 'DESCARGAR_PEDIDOS_EXCEL'
  }